// extracted by mini-css-extract-plugin
module.exports = {"link":"_1fbEI","root":"_2UgQw","label":"_1Qjd7"};